import { render, staticRenderFns } from "./BillingHeader.vue?vue&type=template&id=6e9778c4&"
import script from "./BillingHeader.vue?vue&type=script&lang=js&"
export * from "./BillingHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e9778c4')) {
      api.createRecord('6e9778c4', component.options)
    } else {
      api.reload('6e9778c4', component.options)
    }
    module.hot.accept("./BillingHeader.vue?vue&type=template&id=6e9778c4&", function () {
      api.rerender('6e9778c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/billing/components/BillingHeader.vue"
export default component.exports